import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import { config } from '../ts/config';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';

import * as Common from './menus/Common';
import { IDirsInstanceState, IRenameLoading, IDirItem } from '../ts/stores/DirsStore';

export interface IExpandedItems {
    [key: string]: boolean;
}

class TreeItem extends React.Component<
    {
        id: number | string;
        cid?: number;
        instanceId: string;
        collapsed?: boolean;
        name: string;
        dirs: IDirItem[];
        rename: number;
        icon?: string;
        select: number;
        renameLoading: IRenameLoading;
        expandedItems?: IExpandedItems;
        //dragScope: string;
        glob: IGlob;

        onSelect(id): void;
        onDrop(payload, id): void;
    },
    {
        collapsed: boolean;
        nameEdit: string;
        editFieledChanged: boolean;
    }
> {
    private references: {
        edit?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        let collapsed;
        if (this.props.collapsed != null) {
            collapsed = this.props.collapsed;
        } else {
            collapsed = true;
        }

        // VR: add this feature: expand a needed node!
        if (this.props.expandedItems != null && this.props.expandedItems[this.props.id] === true) {
            collapsed = false;
        }

        this.state = {
            collapsed: collapsed,
            nameEdit: this.props.name,
            editFieledChanged: false
        };
    }

    setRenameState() {
        let input = this.references.edit;
        input.focus();
        $(input).select();
    }

    componentDidMount() {
        let key = this.props.id || this.props.cid;

        if (this.props.rename === key) {
            this.setRenameState();
        }
    }

    // handleDrop = (e, ui) => {
    //     let payload = $(ui.draggable).data('payload');

    //     if (typeof this.props.onDrop === 'function') {
    //         this.props.onDrop(payload, this.props.id);
    //     }
    // };

    handleOnTogglerClick = (e) => {
        this.setState({
            collapsed: !this.state.collapsed
        });

        e.stopPropagation();
        e.preventDefault();
    };

    handleExpand = (e) => {
        this.setState({
            collapsed: false
        });

        e.stopPropagation();
        e.preventDefault();
    };

    getSelectHandler = (id) => {
        let _self = this;

        return (e) => {
            if (id == null || _self.props.renameLoading[id]) {
                return;
            }

            _self.setState({
                nameEdit: e.target.textContent,
                editFieledChanged: true
            });

            if (typeof _self.props.onSelect === 'function') {
                _self.props.onSelect(id);
            }
        };
    };

    handleRenameChange = (e) => {
        this.setState({
            nameEdit: e.target.value,
            editFieledChanged: true
        });
    };

    handleRenameEnd = (e) => {
        this.setState({
            editFieledChanged: false
        });

        let key = (this.props.id as number) || this.props.cid;

        this.props.glob.AppActions.dirsRenameEnd(key, this.state.nameEdit, this.props.instanceId);

        e.preventDefault();
    };

    handleRenameClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    handlelistOnLick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    componentDidUpdate(prevProps, prevState) {
        let key = this.props.id || this.props.cid;

        if (this.props.rename === key && prevProps.rename !== key) {
            this.references.edit.focus();
        }
        let collapsed = true;
        if (
            prevProps.expandedItems != this.props.expandedItems &&
            this.props.expandedItems != null &&
            this.props.expandedItems[this.props.id] === true
        ) {
            collapsed = false;
            this.setState({
                collapsed: collapsed
            });
        }

        if (this.props.rename === key && !this.state.editFieledChanged) {
            let input = this.references.edit;
            if (input) {
                // input.focus();
                $(input).select();
            }
        }
    }

    render() {
        let toggler;
        let title;

        let key = this.props.id || this.props.cid;

        if (this.props.dirs.length > 0) {
            toggler = (
                <i
                    className={'fa toggle' + (this.state.collapsed ? ' fa-caret-right' : ' fa-caret-down')}
                    onClick={this.handleOnTogglerClick}
                ></i>
            );
        }

        if (this.props.rename === key && !this.props.renameLoading[key]) {
            title = (
                <form onSubmit={this.handleRenameEnd}>
                    <input
                        ref={(input) => {
                            this.references.edit = input;
                        }}
                        value={this.state.nameEdit}
                        onClick={this.handleRenameClick}
                        onChange={this.handleRenameChange}
                        onBlur={this.handleRenameEnd}
                    />
                </form>
            );
        } else {
            title = this.props.name;
        }

        let icon = this.props.icon || 'folder-close';

        return (
            <li
                key={this.props.id}
                onClick={this.handleExpand}
                className={
                    'node-item' +
                    (this.props.id === this.props.select ? ' selected' : '') +
                    (this.props.dirs.length === 0 ? ' leaf' : '') +
                    (this.props.renameLoading[key] ? ' loading' : '')
                }
            >
                {toggler}

                <span className="node-title" onClick={this.getSelectHandler(this.props.id)}>
                    <span className={'folder-icon glyphicon glyphicon-' + icon}></span>

                    {title}
                </span>

                <ul
                    className="nodes-container list-unstyled"
                    onClick={this.handlelistOnLick}
                    style={{
                        display: this.state.collapsed ? 'none' : 'block'
                    }}
                >
                    {_.map(this.props.dirs, (dir: any, i) => {
                        return (
                            <TreeItem
                                key={i}
                                name={dir.name}
                                id={dir.dirid}
                                instanceId={this.props.instanceId}
                                cid={dir.cid}
                                dirs={dir.subdirlist}
                                select={this.props.select}
                                rename={this.props.rename}
                                renameLoading={this.props.renameLoading}
                                expandedItems={this.props.expandedItems}
                                onSelect={this.props.onSelect}
                                glob={this.props.glob}
                                //dragScope={this.props.dragScope}
                                onDrop={this.props.onDrop}
                            />
                        );
                    })}
                </ul>
            </li>
        );
    }
}

interface IDirsTreeState extends IDirsInstanceState {
    select: number;
}

export class DirsTree extends React.Component<
    {
        id: string;
        select?: number;
        rootId: number;
        rootName: string;
        showMyFolders?: boolean;
        showExtendedDirs?: boolean;
        //dragScope?: string;
        collapsed?: boolean;
        expandedItems?: IExpandedItems;
        glob: IGlob;

        onSelect?(id): void;
        onDrop?(payload, id): void;
    },
    IDirsTreeState
> {
    static defaultProps = {
        rootId: config.WIDGETS_ROOT_DIR_ID,
        rootName: config.WIDGETS_ROOT_DIR_NAME
    };

    constructor(props) {
        super(props);
        this.state = _.extend(
            {},

            this.getState(),

            {
                select: this.props.select || this.props.rootId || null
            }
        );
    }

    getState() {
        return this.props.glob.DirsStore.getInstanceState(this.props.id);
    }

    componentDidMount() {
        this.props.glob.DirsStore.addChangeListener(this.onStoreChange);
        this.props.glob.AppActions.dirsContentLoad(this.props.id, this.props.rootId, this.props.rootName, true);
    }

    componentWillUnmount() {
        this.props.glob.DirsStore.removeChangeListener(this.onStoreChange);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.select !== this.state.select) {
            this.setState({ select: nextProps.select });
        }
    }

    onStoreChange = () => {
        this.setState(this.getState());
    };

    handleSelect = (id) => {
        this.setState({
            select: id
        });

        if (typeof this.props.onSelect === 'function') {
            this.props.onSelect(id);
        }
    };

    _getExtendedDir = (id: number | string, title: string, icon: string) => {
        let subfolders: IDirItem[];

        if (typeof id === 'number') {
            let root = this.state.data.dirsHash[id];

            if (root != null && root.subdirlist !== null) {
                subfolders = root.subdirlist;
            }
        }

        return (
            <TreeItem
                key={'ex' + id}
                name={title}
                id={id}
                instanceId={this.props.id}
                dirs={subfolders || []}
                icon={icon}
                collapsed={true}
                select={this.state.select}
                rename={this.state.rename}
                renameLoading={this.state.renameLoading}
                //dragScope={this.props.dragScope}
                glob={this.props.glob}
                onSelect={this.handleSelect}
                onDrop={this.props.onDrop}
            />
        );
    };

    _getView = () => {
        let extendedDirs = [];

        if (this.props.showExtendedDirs === true) {
            extendedDirs = [
                this._getExtendedDir(Common.RECENT, 'Recent', 'time'),
                this._getExtendedDir(Common.FAVORITES, 'Favourite', 'star')
            ];
        }

        if (this.props.showMyFolders === true && this.props.glob.AuthStore._state.homeFolderId > 0) {
            extendedDirs.push(this._getExtendedDir(this.props.glob.AuthStore._state.homeFolderId, 'My Folder', 'home'));
        }

        return [
            <ul className="nodes-container list-unstyled" key="dirs-tree-content">
                {extendedDirs}

                <TreeItem
                    key={this.props.id}
                    name={this.props.rootName || 'Root'}
                    id={this.props.rootId}
                    instanceId={this.props.id}
                    dirs={this.state.data.dirs || []}
                    collapsed={this.props.collapsed}
                    select={this.state.select}
                    rename={this.state.rename}
                    renameLoading={this.state.renameLoading}
                    expandedItems={this.props.expandedItems}
                    //dragScope={this.props.dragScope}
                    glob={this.props.glob}
                    onSelect={this.handleSelect}
                    onDrop={this.props.onDrop}
                />
            </ul>
        ];
    };

    render() {
        let content;

        if (this.state.loading) {
            content = <ProgressBar />;
        } else {
            content = this._getView();
        }

        return <div className="dirs-tree">{content}</div>;
    }
}
